import React, { forwardRef, useRef, useContext } from "react";
import { useSelector } from "react-redux";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { useEventContext } from "../../contexts/EventContextProvider";
import ExpandableTokens from "../../widgets/ExpandableTokens";


const TagDiscountsDisplayBar = forwardRef((p, r) => {

    const ui_tagDiscounts = useSelector(state => state.ui.ui_tagDiscounts);

    const render = (p) => {
        return (
            <div className="flex-row" ref={r}>
                <div className="col-24">
                    <div className="ListItemDetails">
                        <div className="flex-column">
                            <div className="flex-row">
                                <div className="col-24">
                                    <ExpandableTokens list={p.discounts} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const renderCase = (state) => {
        
        switch (true) {
            case state?.state == 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case state.visibility:
                return render(state.data);
            case state?.state == 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    //console.log('TagDiscountsDisplayBar', ui_tagDiscounts)
    return (ui_tagDiscounts && ui_tagDiscounts[p.id]) ? renderCase(ui_tagDiscounts[p.id]) : <></>;
});

export default TagDiscountsDisplayBar;